import type { AppRouteRecordRaw } from '@/router/types'
import { mapRepastPath } from '@/utils/repastRedirect'

/**
 * 旧 /repast、/catering-app 书签 → 新统一管理路由（仅重定向，不再挂载旧壳）
 */
const repastRedirect = (to: { params: Record<string, unknown>; query: Record<string, unknown>; hash: string }) => {
  const raw = to.params.pathMatch
  const rest = Array.isArray(raw) ? raw.join('/') : String(raw || '')
  return {
    path: mapRepastPath(rest ? `/repast/${rest}` : '/repast/home'),
    query: to.query,
    hash: to.hash
  }
}

const cateringAppRoutes: AppRouteRecordRaw[] = [
  {
    path: '/repast/:pathMatch(.*)*',
    redirect: repastRedirect,
    meta: { hidden: true }
  },
  {
    path: '/repast',
    redirect: () => mapRepastPath('/repast/home'),
    meta: { hidden: true }
  },
  {
    path: '/catering-app/:pathMatch(.*)*',
    redirect: repastRedirect,
    meta: { hidden: true }
  }
]

export default cateringAppRoutes
